/* Drives the overflow affordances on horizontally scrolling rows: the edge
   fade (assets/component-scroll-hint.css) and the chevron buttons
   (assets/component-quick-filters.css).

   The point is that both are MEASURED, not assumed: they appear only where
   the content actually overflows, and flip to the other edge when you reach
   the end. That is what makes them read as "there is more" rather than as
   decoration - a permanent fade looks identical whether or not the row
   scrolls, so it tells the user nothing.

   Loaded once from layout/theme.liquid; the guard below keeps a second copy
   (e.g. an older section still tagging it) a no-op.

   Performance: measure every row FIRST, then write every class. Reading
   scrollWidth straight after toggling a class forces the browser to redo the
   page layout, and doing that once per card cost ~350 ms of main thread on a
   mid-range phone (Lighthouse "forced reflow"). Batched, it is one layout. */
(function () {
  if (window.__scrollHintReady) return;
  window.__scrollHintReady = true;

  var SELECTOR = '.qf__row, .mattress-card__chips';

  function measure(el) {
    var max = el.scrollWidth - el.clientWidth;
    return { el: el, max: max, left: el.scrollLeft };
  }

  function apply(m) {
    var overflowing = m.max > 2;
    m.el.classList.toggle('has-overflow', overflowing);
    m.el.classList.toggle('at-start', m.left <= 1);
    m.el.classList.toggle('at-end', !overflowing || m.left >= m.max - 1);
  }

  function updateAll(els) {
    var measured = [];
    for (var i = 0; i < els.length; i++) measured.push(measure(els[i]));
    for (var j = 0; j < measured.length; j++) apply(measured[j]);
  }

  var resizeObserver = typeof ResizeObserver === 'function'
    ? new ResizeObserver(function (entries) {
        updateAll(entries.map(function (entry) { return entry.target; }));
      })
    : null;

  function onScroll(event) {
    apply(measure(event.currentTarget));
  }

  function scan() {
    var fresh = [];
    document.querySelectorAll(SELECTOR).forEach(function (el) {
      if (el.dataset.scrollHint) return;
      el.dataset.scrollHint = '1';
      el.classList.add('scroll-hint');
      el.addEventListener('scroll', onScroll, { passive: true });
      if (resizeObserver) resizeObserver.observe(el);
      fresh.push(el);
    });
    if (fresh.length) updateAll(fresh);
  }

  var queued = false;
  function scanSoon() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      scan();
    });
  }

  /* Chevrons. Delegated so buttons added by a later filter re-render work
     without re-binding. Scrolls by most of a screenful but keeps a sliver of
     the previous pill in view, so the user can see where they came from. */
  document.addEventListener('click', function (event) {
    var button = event.target.closest ? event.target.closest('.qf__nav') : null;
    if (!button) return;
    var row = button.parentElement.querySelector('.qf__row');
    if (!row) return;
    event.preventDefault();
    var step = Math.max(120, Math.round(row.clientWidth * 0.8));
    row.scrollBy({
      left: button.classList.contains('qf__nav--prev') ? -step : step,
      behavior: 'smooth'
    });
  });

  scan();
  document.addEventListener('DOMContentLoaded', scan);
  window.addEventListener('load', scan);
  window.addEventListener('resize', scanSoon, { passive: true });

  /* The grid is re-rendered in place when a filter changes, so new chip
     rows appear without a page load. Only react to mutations that ADD
     elements: apps (chat, reviews, Klarna) mutate the page constantly, and
     attribute or text changes can never create a new row. */
  if (typeof MutationObserver === 'function') {
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        if (records[i].addedNodes.length) {
          scanSoon();
          return;
        }
      }
    }).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }
})();
